export default __webpack_public_path__ + "static/media/MineFI_white.79bc07f2.jpg";